import api from './authService'

export interface DraftData {
    id?: string
    name?: string
    description?: string
    technicalDetails?: string
    techKeywords?: string[]
    isBuilt?: boolean
    preferences?: any
}

export const draftService = {
    async getDrafts() {
        const response = await api.get('/drafts')
        return response.data
    },

    async saveDraft(data: DraftData) {
        const response = await api.post('/drafts', data)
        return response.data
    },

    async deleteDraft(id: string) {
        const response = await api.delete(`/drafts/${id}`)
        return response.data
    }
}
